<script lang='ts' setup>
const { switchToWebsite, isLoading } = useWebsiteSwitch();
const { data, status } = useUserWebsitesStore();

const open = ref(false);

const getActiveWebsiteName = () => {
	if (data.value?.activeWebsite) {
		return data.value.activeWebsite.name;
	}
	return '- Select -';
};

const handleSwitchWebsite = async (websiteId: string) => {
	if (data.value?.activeWebsite?.id === websiteId) {
		open.value = false;
		return;
	}
	await switchToWebsite(websiteId);
	open.value = false;
};
</script>

<template>
	<div v-if="status === 'pending' || isLoading" class="flex items-center justify-center p-2">
		<UIcon name="i-lucide-refresh-ccw" size="sm" class="animate-spin" />
	</div>

	<UCollapsible v-else-if="data !== null" v-model:open="open" class="border border-muted rounded-md">
		<UButton :class="{ 'rounded-b-none border-b border-muted': open }" class="w-full justify-between" color="neutral"
			variant="ghost" :label="getActiveWebsiteName()"
			:trailing-icon="open ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'" />

		<template #content>
			<div v-if="isLoading" class="flex justify-center">
				<UIcon name="i-lucide-refresh-ccw" size="lg" class="animate-spin" />
			</div>
			<div v-else-if="data" class="flex flex-col space-y-1 p-1">
				<UButton v-for="website in data.websites" :key="website.id" class="w-full justify-start" :label="website.name"
					:icon="website.id === data.activeWebsite?.id ? 'i-lucide-check' : undefined"
					:color="website.id === data.activeWebsite?.id ? 'primary' : 'neutral'"
					:variant="website.id === data.activeWebsite?.id ? 'soft' : 'ghost'" @click="handleSwitchWebsite(website.id)"
					size="sm" />
				<UButton v-if="data.websites.length === 0" class="w-full justify-start" label="Create Website"
					icon="i-lucide-plus" color="primary" variant="soft" to="/profile/website/create" size="sm" />
			</div>
		</template>
	</UCollapsible>
</template>
